import { TPatient } from './types';
import { patientBaseModel } from './crud';
import { useCreateMutation } from '../../CRUD';
import { axiosService } from '../../services/axiosService';

type TUsePatientLoginParams = {
  patient: Partial<TPatient>;
  shouldCreatePatientOnLoginFailure?: boolean;
  createPatientData?: Partial<TPatient>;
};

type TUsePatientLoginResponse = string;

const { keys } = patientBaseModel;

export const usePatientLogin = () => {
  const mutationFn = async ({
    patient,
    shouldCreatePatientOnLoginFailure,
    createPatientData,
  }: TUsePatientLoginParams) => {
    let response;

    try {
      response = await axiosService.post(`${keys.basicUrlPath}/login`, patient);
    } catch (error) {
      /*
       * it will only create a new patient as login's fallback if it returns 404
       * it confirm patient doesn't exists yet, avoiding patients duplication
       */
      if (error.response.status === 404 && shouldCreatePatientOnLoginFailure) {
        response = await axiosService.post(
          keys.basicUrlPath,
          createPatientData || patient,
        );
      } else {
        throw error;
      }
    }

    return response?.data?._id as TUsePatientLoginResponse;
  };

  return useCreateMutation<TUsePatientLoginResponse, TUsePatientLoginParams>(
    keys.all,
    mutationFn,
  );
};
